export const formatForSelect = (dataToFormat) => {
  let selectData = [];
  dataToFormat.sort(({ id: a }, { id: b }) => a - b);
  dataToFormat.forEach((value) => {
    selectData.push({
      key: value.id,
      text: value.name,
      value: {
        id: value.id,
        name: value.name,
        detailsRequired: value.detailsRequired,
      },
    });
  });
  return selectData;
};
